// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1Dm0o","question":"Question_question__1bpMg","description":"Question_description__13vRF"};